import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	customIconButton: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		},
		width: 5,
		height: 5
	},
	root: {
		display: "flex",
		alignItems: "center"
	},
	methodSelect: {
		minWidth: 100,
		height: 50,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0
	},
	urlRootInput: {
		borderTopLeftRadius: 0,
		height: 50,
		borderBottomLeftRadius: 0,
		flex: 1
	}
})

export default useStyles
